import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FaPlus } from 'react-icons/fa';

import { AddTask, ActiveTodo, DefaultMessage } from '../components';

const Inbox = () => {
  const [addTask, showAddTask] = useState(false);
  const dispatch = useDispatch();
  const todos = useSelector(({ todos }) => todos.filter((todo) => !todo.completed));

  const showModal = () => {
    showAddTask(!addTask);
  };

  const onAddTodo = (todo) => {
    dispatch({ type: 'ADD_TODO', payload: todo });
  };

  const onCompleteTodo = (id) => {
    dispatch({
      type: 'CHANGE_TODO_STATUS',
      payload: {
        id,
        status: true,
      },
    });
  };

  const onDeleteTodo = (id) => {
    dispatch({
      type: 'DELETE_TODO',
      payload: id,
    });
  };

  return (
    <div className="inbox page">
      <div className="small-container inbox__inner">
        {todos.length === 0 && <DefaultMessage>Click add task to create a new task</DefaultMessage>}
        <div className="inbox__header">
          <h5 className="inbox__header-title">Inbox</h5>
          <div className="inbox__add" onClick={showModal}>
            Add Task
            <FaPlus />
          </div>
        </div>
        <div className="inbox__modal">
          {addTask && <AddTask onCancel={showModal} onAdd={onAddTodo} />}
        </div>
        <div className="inbox__content">
          {todos &&
            todos.map((obj) => {
              return (
                <ActiveTodo
                  onDelete={onDeleteTodo}
                  onComplete={onCompleteTodo}
                  key={obj.id}
                  {...obj}
                />
              );
            })}
        </div>
      </div>
    </div>
  );
};

export default Inbox;
